import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { useActionableCommentStore } from '@/features/actionable-comment'
import { ThreadActionableType } from '@/schema'

interface ActionableProps {
  actionableType: ThreadActionableType
  threadId: string
  assigneeId?: string
}

export const Actionable: React.FC<ActionableProps> = ({
  actionableType,
  threadId,
  assigneeId,
}) => {
  const { t } = useTranslation()
  const { setActionableDialogOpen, setNotActionableDialogOpen } =
    useActionableCommentStore()

  const isShowAction = actionableType === ThreadActionableType.NONE

  if (!isShowAction) {
    return <></>
  }

  return (
    <div className="flex items-center ml-2">
      <Button
        variant="text"
        className="h-auto px-3 py-2 text-sm font-medium text-brand-tertiary-600"
        onClick={(e) => {
          e.stopPropagation()
          setActionableDialogOpen({
            open: true,
            threadId,
            assigneeId: assigneeId || null,
          })
        }}
      >
        {t('comment.actions.actionable')}
      </Button>
      <Button
        variant="text"
        className="h-auto px-3 py-2 text-sm font-medium text-brand-tertiary-600"
        onClick={(e) => {
          e.stopPropagation()
          setNotActionableDialogOpen(true, threadId)
        }}
      >
        {t('comment.actions.notActionable')}
      </Button>
    </div>
  )
}
